import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { useFormattedCurrencyDisplay } from '../hooks/useFormattedCurrencyDisplay';
import { EMPTY_PROPERTY_VALUE } from '../../constants/EmptyPropertyValue';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyCurrencyV2 = props => {
  const {
    placeholder = EMPTY_PROPERTY_VALUE,
    currencyProps = {}
  } = props;
  useComponentMountMetric('FormattedPropertyCurrencyV2');
  const {
    currencyValue,
    currencyCode,
    formattingOptions: {
      shouldSimplifyCurrency,
      fractionalCurrencyProps
    }
  } = useFormattedCurrencyDisplay({
    defaultCurrencyCode: currencyProps.currencyCode,
    shouldSimplifyCurrency: currencyProps.simplifyCurrency
  });
  if (currencyValue === null) {
    return /*#__PURE__*/_jsx("span", {
      children: placeholder
    });
  }
  if (!currencyCode) {
    return /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedIntlCurrency, Object.assign({}, currencyProps, fractionalCurrencyProps, {
        trailingZeroDisplay: shouldSimplifyCurrency ? 'stripIfInteger' : 'auto',
        value: currencyValue
        // Intentionally hide the currency symbol while loading,
        // or if we have an error loading the home currency
        // NOTE: use a blank space instead of an empty string to silence the
        // warning: 'I18n: Missing currencyCode in call to formatCurrency().'
        // It looks identical (browser collapses leading whitespace)
        ,
        unit: " "
      }))
    });
  }
  return /*#__PURE__*/_jsx("span", {
    "data-selenium-test": "currency-component-loaded",
    children: /*#__PURE__*/_jsx(FormattedIntlCurrency, Object.assign({}, currencyProps, fractionalCurrencyProps, {
      currencyCode: currencyCode,
      trailingZeroDisplay: shouldSimplifyCurrency ? 'stripIfInteger' : 'auto',
      value: currencyValue
    }))
  });
};
FormattedPropertyCurrencyV2.displayName = 'FormattedPropertyCurrencyV2';
export default FormattedPropertyCurrencyV2;